import request from '@/util/server.js'

// export const settled = 'http://43.143.103.3:10014/settled' // 商家入驻地址
export const settled = 'https://jiankangjia.online/settled' // 商家入驻地址

// 获取首页导航栏分类
export function getCategory () {
  return request({
    url: '/classify/getFirstClassify',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/nav.js